import type { StrictOmit } from '@listening/api-contract/legacy-client-types';
import type { ComponentProps } from 'react';
import { AudioChunkPlayerProviderInternal } from './core';
import { AudioPoolPlayerProvider } from './player';

export {
  getDocPackPlaybackAnchorForPosition,
  useCurrentAudioChunkQuery,
  useDocumentSummary,
  usePreferedVoice,
  type DocPackPlaybackAnchor,
} from './core';

export * from './seek-bar';
export * from './hooks';

export function AudioChunkPlayerProvider({
  children,
  poolPlayerOptions,
  ...props
}: ComponentProps<typeof AudioChunkPlayerProviderInternal> & {
  poolPlayerOptions?: StrictOmit<
    ComponentProps<typeof AudioPoolPlayerProvider>,
    'children'
  >;
}) {
  return (
    <AudioPoolPlayerProvider {...poolPlayerOptions}>
      <AudioChunkPlayerProviderInternal {...props}>
        {children}
      </AudioChunkPlayerProviderInternal>
    </AudioPoolPlayerProvider>
  );
}
